import { render, staticRenderFns } from "./ModalOrdenesComponent.vue?vue&type=template&id=93f4c5e8&scoped=true"
import script from "./ModalOrdenesComponent.vue?vue&type=script&lang=js"
export * from "./ModalOrdenesComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalOrdenesComponent.vue?vue&type=style&index=0&id=93f4c5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f4c5e8",
  null
  
)

export default component.exports